module.exports = __webpack_public_path__ + "static/media/onboard-9-activity.677d4ac1.gif";